import TextConstants from './TextConstants';

/**
 * @description Get the data type of channel by input is the type number
 * @param {string} type
 * @returns {string} Channel data type
 */
const getChannelDataType = (type) => {
  switch (parseInt(type)) {
    case 0:
      return 'Number';
    case 1:
      return 'Boolean';
    case 2:
      return 'String';
    case 3:
      return 'Binary Data';
    case 4:
      return 'Location Data';
    default:
      return 'Unknown';
  }
};

const getFullName = (user) => {
  let firstName = user.firstName ? user.firstName : '';
  let lastName = user.lastName ? user.lastName : '';
  return `${firstName} ${lastName}`.trim() || 'ー';
};

const ROLE_CST = TextConstants.Common.RolesConst;

const getDefaultPagePath = (role) => {
  switch (role) {
    case ROLE_CST.HEATMAP_ADMIN:
      return '/heatmap-measurements';
    case ROLE_CST.SUPER_ADMIN:
      return '/users-management';

    case ROLE_CST.COMPANY_ADMIN:
    case ROLE_CST.DEVICE_ADMIN:
    case ROLE_CST.STORE_ADMIN:
    case ROLE_CST.GENERAL_USER:
      return '/dashboard';

    default:
      return '/login';
  }
};

const downloadJsonFileFromObject = (fileName, Obj) => {
  const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
    JSON.stringify(Obj)
  )}`;
  const link = document.createElement('a');
  link.href = jsonString;
  link.download = fileName;

  link.click();
};

export const ZoomLevel = [
  { label: 'FIT', value: 'FIT' },
  { label: 125, value: 0.3 },
  { label: 150, value: 0.5 },
  { label: 200, value: 0.7 },
  { label: 300, value: 1 },
];

export const uploadS3File = (signedData, file) => {
  const formdata = new FormData();
  // Add fields keys values
  Object.keys(signedData?.fields || {}).forEach((key) => {
    formdata.append(key, signedData?.fields[key]);
  });
  // Add file
  formdata.append('file', file);

  const options = {
    method: 'POST',
    body: formdata,
  };

  // hotfix for the CORS issue
  // @TODO: Fix this
  const url = signedData.url.replace('.s3.', '.s3-ap-northeast-1.');

  return new Promise((resolve, reject) => {
    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          reject(response);
        }
        return resolve(response);
      })
      .catch((e) => reject(e));
  });
};

export default {
  getChannelDataType,
  getFullName,
  uploadS3File,
  getDefaultPagePath,
  downloadJsonFileFromObject,
};
